export default {
    empty: '退会済みのメンバーはいません。',
    endDate: '退会日',
    name: '名前',
    reactivate: '再登録',
    startDate: '加入日',
    subtitle: '次のメンバーはこの企業から退会しました。',
    title: '退会済みメンバー',
};
